<p>attendance-lisitng works!</p>